module.exports = __webpack_public_path__ + "img/bg_footer.29959ec3.png";